import { render, staticRenderFns } from "./yijiyou.vue?vue&type=template&id=56fe860d&scoped=true&"
import script from "./yijiyou.vue?vue&type=script&lang=js&"
export * from "./yijiyou.vue?vue&type=script&lang=js&"
import style0 from "./yijiyou.vue?vue&type=style&index=0&id=56fe860d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fe860d",
  null
  
)

export default component.exports